/*
*###############################################################################
*Module Name                   : StockFreezeGroup.js                           #
*Purpose of the Module         :                                               #
*Description of the Module     :                                               #
*Original Author               :  T A C Priyashad                              #
*Date                          : Wednesday, March 2nd 2022, 9:09:49 am         #
*Copyright (c) 2022 myPOS Software Solution (pvt Ltd.)                         #
*###############################################################################
*/
import React, { useState, useEffect } from "react"
import { Row, Col, Button } from "reactstrap"
import Switch from "react-switch"
import DPTextBoxforgrid from "../../../framework/components/DPTextBoxforgrid"
import DPSearchBox from "framework/components/DPSearchBox"
import { getGroupDetails } from "./StockFreezeController"
import DPSearchBoxDynamic from "framework/components/DPSearchBoxDynamic"
import DPStockFreezePopUp from "framework/components/DPStockFreezePopUp"

const StockFreezeGroup = ({ DataRow, Disabled, menuCode, clearChange, GrpData }) => {
  return (
    <React.Fragment>
      <Row>
        <Col sm={12} md={12} className="mb-12-sm" style={{ maxHeight: 200, overflowY: 'auto' }}>
          <table style={{ fontSize: "11px" }} id={"GroupDet"}>
            <thead className="table-light">
              <tr>
                <th>No </th>
                <th>Name </th>
                <th>Selected Codes </th>
                <th></th>
              </tr>
            </thead>
            <tbody disabled={true}>
              {(DataRow || []).map((DataRow, key) => (
                <TableRow FormRow={DataRow} Key={key} Disabled={Disabled} menuCode={menuCode} clearChange={clearChange} GrpData={GrpData} />
              ))}
            </tbody>
          </table>
        </Col>
      </Row>
    </React.Fragment>
  )
}
export default StockFreezeGroup

const TableRow = ({ FormRow, Key, Disabled, menuCode, clearChange, GrpData }) => {
  const ApiURL = window.Links.ApiURL
  const authToken = localStorage.getItem("authToken")

  const [code, setCode] = useState([])

  const [modal_xlarge, setmodal_xlarge] = useState(false)

  const [groupData, setGroupData] = useState([])

  useEffect(() => {
    fetch(`${ApiURL}Group/all/${FormRow.code}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${authToken}`
      },
    })
      .then(Response => Response.json())
      .then(responseData => {
        if (responseData.success == true) {
          setGroupData(responseData.data)
        }
      })
  }, [])


  useEffect(() => {
    setCode([])
  }, [clearChange])


  function GroupSearch(value) {

  }
  function tog_xlarge() {
    setmodal_xlarge(!modal_xlarge)
    removeBodyCss()
  }
  async function clickSearch() {
    tog_xlarge()
  }



  function removeBodyCss() {
    document.body.classList.add("no_padding")
  }


  //* End Code Validation   */
  return (
    <tr key={FormRow.id}>
      <td style={{ width: "50px" }}>
        <Row className="mb-0">
          <Col md="12">
            <DPTextBoxforgrid
              rowClass="mb-12-sm"
              labelText="Code"
              textType="text"
              disabled={true}
              id={"txtCode" + Key}
              value={FormRow.code}

            ></DPTextBoxforgrid>
          </Col>
        </Row>
      </td>
      <td style={{ width: "200px" }}>
        <Row className="mb-0">
          <Col md="12">
            <DPTextBoxforgrid
              rowClass="mb-12-sm"
              labelText="Code"
              textType="text"
              disabled={true}
              id={"txtdesc" + Key}
              value={FormRow.name}

            ></DPTextBoxforgrid>
          </Col>
        </Row>
      </td>
      <td style={{ width: "400px" }}>
        <Row className="mb-0">
          <Col md="12">
            <DPTextBoxforgrid
              labelText="Code"
              textType="text"
              disabled={true}
              id={"txtGroupcode" + Key}
              value={code.join(',')}

            ></DPTextBoxforgrid>
          </Col>
        </Row>
      </td>
      <td style={{ paddingLeft: '5px' }}>
        <Row className="mb-0">
          <Col md="12">
            <Button
              outline
              disabled={Disabled ? true : GrpData.length > 0 ? true : false}
              color="success"
              id={"btnGroupSearch" + Key}
              onClick={clickSearch}
              size="sm"
            >
              <i
                className="mdi mdi-search-web"
                style={{ fontSize: "12px" }}
              ></i>
            </Button>
          </Col>
        </Row>
      </td>

      <td>
        <Row className="mb-0">
          <DPStockFreezePopUp
            isOpen={modal_xlarge}
            toggle={tog_xlarge}
            data={groupData}
            mainTitle={FormRow.name}
            code={code}
            setCode={setCode}
          />
        </Row>
      </td>
    </tr>
  )
}
